import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    box: {
      backgroundColor: Colors.WHITE,
      borderRadius: theme.spacing(1),
      height: theme.spacing(37.5),
      padding: theme.spacing(4),
      position: 'relative',
    },
    title: {
      ...CommonFonts.darkFont16,
      fontWeight: 600,
      paddingBottom: theme.spacing(3),
    },
    text: {
      ...CommonFonts.darkFont14,
    },
    currency: {
      ...CommonFonts.darkFont14,
      fontWeight: 600,
    },
    amount: {
      ...CommonFonts.darkFont24,
      fontWeight: 600,
    },
    payButton: {
      marginTop: theme.spacing(2),
      width: '100%',
      textTransform: 'capitalize',
      padding: theme.spacing(3, 0),
    },
  })
);

export default useStyles;
